// extracted by mini-css-extract-plugin
export default {"section_heading":"SectionHeading_section_heading__a-9kj"};